import React, { Fragment, createContext, useRef } from "react";
import { Modal, ModalContent, ModalBody, ModalCloseButton, Link, useDisclosure, VStack } from "@chakra-ui/react";

import { TextAccent, TextSmall } from "../Text";
import { LoginWidget } from "../LoginWidget";
import { modalSlideFade } from "../../transitions";
import {
  LOGIN_FORM_CONTAINER_WIDTH,
  BORDER_RADIUS_30,
  COLOR_BLACK_OPACITY_025,
  SPACING_30,
  SPACING_20,
  SPACING_32,
  FONT_SIZE_20,
  COLOR_WHITE,
  COLOR_BLACK,
} from "../../constants/styles";
import { ModalOverlayBlur25 } from "../Modal";

function AuthModal({ isOpen, onClose, onSuccess }) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlayBlur25 />

      <ModalContent
        motionProps={modalSlideFade}
        borderRadius={BORDER_RADIUS_30}
        w={LOGIN_FORM_CONTAINER_WIDTH}
        minW={LOGIN_FORM_CONTAINER_WIDTH}
        backgroundColor={COLOR_WHITE}
        pt={SPACING_20}
      >
        <ModalCloseButton
          top={SPACING_20}
          right={SPACING_20}
          color={COLOR_BLACK_OPACITY_025}
          w={SPACING_32}
          h={SPACING_32}
          fontSize={FONT_SIZE_20}
        />
        <ModalBody p={SPACING_30} display="flex" justifyContent="center">
          <LoginWidget
            noBg
            onSuccess={onSuccess}
            header={
              <VStack spacing={0}>
                <TextAccent textAlign="center" lineHeight="shorter" color={COLOR_BLACK}>
                  Войдите или зарегистрируйтесь,
                </TextAccent>
                <TextAccent textAlign="center" lineHeight="shorter" color={COLOR_BLACK}>
                  чтобы продолжить:
                </TextAccent>
              </VStack>
            }
            footer={
              <VStack spacing={0} color={COLOR_BLACK_OPACITY_025}>
                <TextSmall textAlign="center" lineHeight="shorter">
                  При входе вы соглашаетесь{" "}
                </TextSmall>
                <TextSmall textAlign="center" lineHeight="shorter">
                  <Link href="/legal/public" textDecor="underline">
                    с правилами пользования сервисом
                  </Link>
                </TextSmall>
              </VStack>
            }
            colorMode="light"
          />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}

export const AuthContext = createContext();

export function AuthProvider({ children, onSuccess }) {
  const { isOpen, onClose, onOpen } = useDisclosure();
  const successCb = useRef(null);

  function login(cb) {
    successCb.current = cb;
    onOpen();
  }

  function _onSuccess() {
    typeof successCb.current === "function" && successCb.current();
    typeof onSuccess === "function" && onSuccess();
    onClose();
  }

  return (
    <AuthContext.Provider
      value={{
        login,
      }}
    >
      <AuthModal isOpen={isOpen} onClose={onClose} onSuccess={_onSuccess} />
      <Fragment>{children}</Fragment>
    </AuthContext.Provider>
  );
}
